import { Button } from "@growtherapy/sprout-ui";
import { useState } from "react";
import { useVisitorConnectRoomCallback } from "./admission/useVisitorConnectRoomCallback";
import { useAdmissionTrackingEvents } from "./admission/useAdmissionTrackingEvents";

export function JoinSessionButton({
  onJoin: handleJoin,
  isLoading,
}: {
  onJoin: () => void;
  isLoading: boolean;
}) {
  return (
    <Button
      use="primary"
      size="md"
      className="w-full"
      onClick={handleJoin}
      loading={isLoading}
    >
      Join session
    </Button>
  );
}

export function JoinSessionButtonWrapper() {
  const connectRoom = useVisitorConnectRoomCallback();
  const [isLoading, setIsLoading] = useState(false);
  const { trackJoinSessionClicked } = useAdmissionTrackingEvents();

  return (
    <JoinSessionButton
      onJoin={() => {
        setIsLoading(true);
        connectRoom().finally(() => setIsLoading(false));
        trackJoinSessionClicked();
      }}
      isLoading={isLoading}
    />
  );
}
